/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Indexnow_RecheckInputs */

const en_admin_indexnow_recheck = /** @type {(inputs: Admin_Indexnow_RecheckInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Re-check`)
};

/**
* | output |
* | --- |
* | "Re-check" |
*
* @param {Admin_Indexnow_RecheckInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const admin_indexnow_recheck = /** @type {((inputs?: Admin_Indexnow_RecheckInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Indexnow_RecheckInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_admin_indexnow_recheck(inputs)
});
export { admin_indexnow_recheck as "admin.indexnow.recheck" }